import React from 'react';
import TabBar from "../../TabBar";
import { SwitchInput } from "../../Form";
import { inject, observer } from "mobx-react/index";

@inject('workOrderStore')
@observer
class WorkOrderHome extends React.Component {

  onChangeSwitch = (key) => {
    const { workOrderStore } = this.props;
    workOrderStore.onChangeViewSwitch(key);
    workOrderStore.selectedMarker = null;
  };

  render() {
    const { assigned_to_all, view_archived } = this.props.workOrderStore;

    return (
      <div>
        <div className='inline-grid space-between'>
          <TabBar
            items={[
              { to: '/monitoring/work_order/tabular', label: 'Tabular' },
              { to: '/monitoring/work_order/map', label: 'Map' },
              { to: '/monitoring/work_order/route', label: 'Route' },
              // { to: '/monitoring/ticket/archived', label: 'Archived' },
            ]}
          />
          <div className='inline-grid'>
            <SwitchInput label='Assigned to all' value={assigned_to_all} onChange={() => this.onChangeSwitch('assigned_to_all')} />
            <SwitchInput label='View Archived' value={view_archived} onChange={() => this.onChangeSwitch('view_archived')} />
          </div>
        </div><br />
        {this.props.children}
      </div>
    );
  }
}

export default WorkOrderHome;



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderHome.js